import Constant from '@/const';
import axios from 'axios';

const icareAuthenticationCheck = async () => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat('/integration/pcare/icare/auth'),
    );
    return response;
  } catch (error) {
    const err = error;
    throw err;
  }
};

export default icareAuthenticationCheck;
